export default {"src":"/_next/static/media/business.73b4a568.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};